import styled from 'styled-components'
import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { latinoPlanData } from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'

export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'en' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        //REMOVED: univision_removed video and annotations
        // video={videos.latino.videoUrl}
        // annotations={videos.latino.annotations}
        //REPLACED: univision_removed poster images
        poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
        posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
        title="Save big on live TV for your family"
        subtitle={
          <>
            {laChannelCount}+ channels of sports, news, novelas, and{' '}
            <span className="desktop-line-break">
              entertainment in Spanish for only{' '}
              <span className="green-underline">${laDiscountPriceMonthly}</span> the first month.
            </span>{' '}
          </>
        }
        networkSet={'entertainmentLatino'}
        noteLink="/latino-es/"
        disableLAPlanCards={isLatinoBundleAvailable}
        forceAnchorLink={isLatinoBundleAvailable}
        hasPlanCards={isLatinoBundleAvailable}
        plans={[latinoBundlePlan, latinoPlanData.latino_en_standalone_monthly]}
        plansSharedData={{
          rsn: latinoBundlePlan?.rsn,
          teams: latinoBundlePlan?.teams,
        }}
      />
    </StyledContainer>
  )
}
const StyledContainer = styled.div``
